module.exports = __webpack_public_path__ + "img/img4.88b2389c.png";